import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import ProductHelper from '@iso/lib/api/productHelper';
import { notification } from '@iso/components';
import actions from './actions';
//import JwtAuthentication from '../../helpers/jwtAuthentication';

/**** list of user record *******/
function* ProductReadRequest() {
    yield takeEvery(actions.PRODUCT_LIST, function*({ payload }) {
    try {
        //const {page}=payload.page;
      const searchResult = yield call(ProductHelper.read,payload);
      console.log('---serachResultPRODUCTAPI--', searchResult )
      if (searchResult.status) {
        yield put(
          actions.ProductListSuccess(
            searchResult.exportresult,  
          searchResult.result,
          searchResult.status,
          searchResult.totalRecordCount,
           payload.page
          )
        );
      } else {
        notification("error", searchResult.message);
        yield put(
          actions.ProductListSuccess(  [],  [],0,0, 1)
        );
      }
    } catch (error) {
    }
  });
}
/*****fetch user record  *************/



/**** list of user record *******/
export  function* ProductFindByIdRequest() {
  console.log('search request');
    yield takeEvery(actions.PRODUCT_FETCH_ID, function*({ payload }) {
    try {
      const searchResult = yield call(ProductHelper.findById,payload.listid);
      if (searchResult.status) {
        yield put(
          actions.ProductListById(
          searchResult.result,
          searchResult.message
          )
        );
      } else {
      }
    } catch (error) {
    }
  });
}


/************************************** End UPDATE User  Function ***************************************/

export default function* rootSaga() {
  yield all([
    //  takeEvery(actions.USER_LIST, searchRequest)
    fork(ProductReadRequest),
    fork(ProductFindByIdRequest), 
  ]);
}
